module.exports = __webpack_public_path__ + "static/media/ArtLogo.12f1c902.svg";